import React from 'react';

import {RowItemActionView} from './RowItemActions.styles';
import {useRowItemContext} from '../RowItemContext';

import type {RowItemActionProps} from './_types';

export const RowItemAction = React.forwardRef<
  HTMLButtonElement,
  RowItemActionProps
>(({isDisabled: isDisabledProp, ...props}, ref) => {
  const {itemProps, isDraggedItem, isDragging} = useRowItemContext();
  const {shouldAlwaysShowActions} = itemProps;

  return (
    <RowItemActionView
      {...props}
      dragState={isDragging || isDraggedItem}
      isDisabled={isDisabledProp || itemProps.isDisabled}
      ref={ref}
      shouldHideAction={!shouldAlwaysShowActions}
      variant="ghost"
    />
  );
});

RowItemAction.displayName = 'RowItemAction';
RowItemAction.toString = RowItemActionView.toString;
